<div class="w-100 countdown-container">
    <div class="countdown" [ngClass]="{'showFourBlocks': showAllCountdownBlocks, 'countdown--alternate': useAlternate, 'countdown--flex': makeFlex, 'countdown--yellow-tiles': yellowTiles}">
        <div class="countdown-block" #countBlock [ngClass]="{'hide': showSeconds}">
            <h4 class="countdown-number">{{this.days}}</h4>
            <span class="countdown-text">Dage</span>
            <span class="countdown-line" [style.width.px]="this.hLineWidth"></span>
        </div>
        <div class="countdown-block">
            <h4 class="countdown-number">{{this.hours}}</h4>
            <span class="countdown-text">Timer</span>
            <span class="countdown-line countdown-line--hours" [style.width.px]="this.mLineWidth"></span>
        </div>
        <div class="countdown-block">
            <h4 class="countdown-number">{{this.minutes}}</h4>
            <span class="countdown-text">Minutter</span>
            <span class="countdown-line countdown-line--mins" [style.width.px]="this.sLineWidth"></span>
        </div>

        <div class="countdown-block countdown-secondsblock" *ngIf="showSeconds || showAllCountdownBlocks">
            <h4 class="countdown-number">{{this.seconds}}</h4>
            <span class="countdown-text">Sekunder</span>
            <span class="countdown-line countdown-line--mins" [style.width.px]="this.sLineWidth"></span>
        </div>
    </div>
</div>
